import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Medical, Retail, Ecommerce, Grocery, Education, Construction } from '../assets';
import { map } from 'lodash';
import MenuLinkWithIcon from './MenuLinkWithIcon';

const resources = [
    {
        icon: Medical,
        title: "supportingIndustries.medical",
        //subtitle: "industriesMenu.commonDescription",
    },
    {
        icon: Retail,
        title: "supportingIndustries.retail",
        // subtitle: "industriesMenu.commonDescription",
    },
    {
        icon: Ecommerce,
        title: "supportingIndustries.ecommerce",
        // subtitle: "industriesMenu.commonDescription",
    },
    {
        icon: Grocery,
        title: "supportingIndustries.grocery",
        //subtitle: "industriesMenu.commonDescription",
    },
    {
        icon: Education,
        title: "supportingIndustries.education",
        //subtitle: "industriesMenu.commonDescription",
    },
    {
        icon: Construction,
        title: "supportingIndustries.construction",
        //subtitle: "industriesMenu.commonDescription",
    }
]

const IndustriesMenu = ({ ...props }) => {

    const { t } = useTranslation('public');

    return (
        <Box sx={{ paddingInlineStart: 4, paddingInlineEnd: 6, paddingBlock: 2 }}>
            <Typography sx={{ color: "#1E1E1E", fontSize: '16px', fontStyle: 'normal', fontWeight: 500, lineHeight: '130%', mb: 1 }}>
                {t("Industries")}
            </Typography>
            <Grid container spacing={{ xs: 0, md: 10 }} >
                <Grid item xs={12} md={6}>
                    {
                        map(
                            resources.slice(0, 4),
                            resource => <MenuLinkWithIcon link={resource} sx={{ marginBlock: 2 }} />
                        )
                    }
                </Grid>
                <Grid item xs={12} md={6} sx={{ marginTop: { xs: -2, md: 0 } }}>
                    {
                        map(
                            resources.slice(4),
                            resource => <MenuLinkWithIcon link={resource} sx={{ marginBlock: 2 }} />
                        )
                    }
                </Grid>
            </Grid>
        </Box>
    );
}

export default IndustriesMenu;
